"use client";
import Image from "next/image";
import React from "react";
import SheetBanner from "../../../public/assets/background/sheet_banner.webp";
import { IoCaretForward } from "react-icons/io5";
import CtbBanner from "../../../public/assets/background/sheet_why_bg.jpg";
import GlassImg from "../../../public/assets/background/sheet_bg.jpg";
import Link from "next/link";
import { HiHome } from "react-icons/hi2";
import { BsPatchCheckFill } from "react-icons/bs";
import MoreToExploreMobile from "@/components/product/ExploreMoreMobile";
import MoreToExplore from "@/components/product/ExploreMore";
import { GiMicroscope, GiFactory } from "react-icons/gi";
import { MdHomeRepairService, MdWatchLater } from "react-icons/md";

const SheetGlass = () => {
  const categories = [
    {
      title: "Construction: Windows, doors, facades, partitions",
      icon: <MdHomeRepairService className="text-[#d42427] w-5 h-5" />,
    },
    {
      title: "Consumer Products: Mirrors, wall clocks, furniture",
      icon: <MdWatchLater className="text-[#d42427] w-5 h-5" />,
    },
    {
      title: "Medical & Scientific: Lab slides, diagnostic glass",
      icon: <GiMicroscope className="text-[#d42427] w-5 h-5" />,
    },
    {
      title: "Industrial: Specialized transparent applications",
      icon: <GiFactory className="text-[#d42427] w-5 h-5" />,
    },
  ];
  return (
    <>
      <section className="relative ">
        <div className="grid grid-cols-1 xl:mt-17">
          <Image
            src={SheetBanner}
            alt="flat-glass"
            className="w-full h-full"
            priority={true}
          />
        </div>
        <div className=" breadcrumb">
          <ul className="flex items-center justify-center gap-2 p-2 ">
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm gap-1 text-red-600"
              >
                <HiHome />
                Home
              </Link>
            </li>
            <li className="text-sm text-gray-600">/</li>
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm text-gray-400"
              >
                Sheet Glass
              </Link>
            </li>
          </ul>
        </div>
      </section>

      <section className="xl:py-[50px] pt-[50px] pb-[20px] px-6  xl:mb-5 mb-0">
        <div className="container mx-auto">
          <div className="grid  xl:grid-cols-2  grid-cols-1 gap-5 items-center transition ease-in-out duration-500">
            <div>
              <h2 className="title !text-[#033b6f] !mb-0">
                Transparent{" "}
                <span className="text-[#d42427]"> Sheet Glass </span>
                Solutions
              </h2>
              <h5 className="text-xl  font-semibold">by emerge glass</h5>

              <div className="pt-8">
                <p className="text-gray-700 text-sm md:text-base leading-relaxed text-justify mb-3 ">
                  At <span className="font-bold">Emerge Glass</span>, sheet
                  glass isn’t just a product—it’s our <strong>core strength and legacy</strong> From{" "}
                  <span className="font-bold">
                    1mm ultra-thin transparent glass to 8mm strong glazing
                    sheets
                  </span>
                  , we deliver unmatched clarity, strength, and precision that
                  serve diverse industries.
                </p>

                <p className="text-gray-700 text-sm md:text-base leading-relaxed text-justify mb-3 ">
                  Our state-of-the-art technology makes us the
                  <span className="font-bold">
                    only manufacturer in India capable of producing three
                    thicknesses of sheet glass simultaneously
                  </span>
                  , ensuring efficiency and consistency at scale. This
                  capability allows us to meet the unique needs of industries
                  ranging from{" "}
                  <span className="font-bold">
                    construction and interiors to scientific research and
                    consumer products.
                  </span>
                </p>
              </div>
            </div>

            <div className="">
              <video
                src="https://www.emergeglass.in/sheet.mp4"
                className="rounded-lg"
                autoPlay
                muted
                loop
                playsInline
              ></video>
            </div>
          </div>
        </div>
      </section>
      <section className="xl:py-[80px] !pt-[20px] pb-[50px] px-6">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-6">
            <div className="order-1 lg:order-2 bg-gradient-to-b from-red-50 to-blue-50 p-6 md:p-8 shadow-2xl h-auto lg:h-[90%]  relative z-40 lg:-ml-[20%] rounded-lg border-b-4 border-red-400 flex flex-col justify-center">
              <h2 className="title !text-[#033b6f] !text-center !text-2xl">
                Our <span className="text-[#d42427]"> Sheet Glass </span>
                Portfolio
              </h2>

              <ul className="flex flex-col gap-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      1mm – 8mm Transparent Sheet Glass –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Wide range for multiple industries
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      3mm – 8mm General Glazing Glass –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Perfect for windows, partitions, and facades
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Wall-Clock Glass –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Precision-engineered for timepiece manufacturers
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Blood Test Microslides –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      High clarity and accuracy for diagnostics
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Mirror Glass –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Premium base for reflective applications
                    </span>
                  </p>
                </li>
              </ul>
            </div>

            <Image
              src={GlassImg}
              alt="factory image"
              loading="lazy"
              className="order-2 lg:order-1 rounded-lg relative z-10 w-full h-auto "
            />
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden ">
        <Image
          src={CtbBanner}
          alt="call to action banner"
          className="w-full xl:h-[450px] md:h-[400px] h-[500px] object-cover"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-black/60 z-10"></div>

        <div className="absolute inset-0 xl:w-full w-[92%] xl:left-0 left-1/2 xl:translate-x-0 -translate-x-1/2 flex items-start justify-center z-20 flex-col container mx-auto ">
          <h2 className="xl:text-4xl text-2xl font-bold text-left text-[#fff] mb-5">
            What Makes Our
            <span className="text-red-400"> Sheet Glass Different?</span>
          </h2>

          <ul className="mt-5 flex flex-wrap justify-center gap-4 text-gray-300 xl:w-[60%]">
            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Unmatched Clarity & Finish
                </span>
                <br />
                Smooth, distortion-free surface
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">Strong & Reliable </span>
                <br />
                Built for long-term durability
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Industry Versatility{" "}
                </span>
                <br />
                Construction, medical, industrial & consumer applications
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Pioneering Technology
                </span>
                <br />
                The Only plant in India to manufacture three thicknesses
                together
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Sustainability First{" "}
                </span>
                <br />
                100% recyclable glass
              </p>
            </li>
          </ul>
        </div>
      </section>

      <section className="py-[50px] px-[20px] bg-white">
        <div className="container mx-auto">
          <h2 className="title !text-[#033b6f] !text-center">Applications</h2>

           <ul className="grid xl:grid-cols-4 md:grid-cols-2 gap-8">
          {categories.map((item, index) => (
            <li
              key={index}
              className="flex items-center gap-4 xl:p-6 p-2 bg-gray-50 rounded-lg shadow border border-gray-200"
            >
              <p className="w-[40px] h-[40px] grid place-items-center bg-red-100 rounded-full">
                {item.icon}
              </p>
              <p className="text-gray-700 font-medium flex flex-1">{item.title}</p>
            </li>
          ))}
        </ul>
        </div>
      </section>
      <section className=" py-[50px] xl:pb-[100px] px-4 md:px-0 relative bg-gradient-to-b from-gray-800 to-[#fbf9f5]">
        <div className="">
          <h2 className="title !text-[#fff] !text-center">
            Explore <span className="text-[#d42427]"> More </span>
            Products
          </h2>

          <MoreToExplore />
          <MoreToExploreMobile />
        </div>
      </section>
    </>
  );
};

export default SheetGlass;
